var _defs, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMarkerLab = function SvgMarkerLab(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74.998,
    height: 109.616,
    viewBox: "0 0 74.998 109.616",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#64b246;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M438.154,1851.713a37.5,37.5,0,0,0-37.5,37.5c0,20.71,36.417,72.117,36.417,72.117s38.581-51.407,38.581-72.117A37.5,37.5,0,0,0,438.154,1851.713Zm14.7,56.758a5.048,5.048,0,0,1-4.54,2.529H427.474a5.106,5.106,0,0,1-4.541-2.529,5.23,5.23,0,0,1-.286-5.15L432,1890.25V1878h-.036a1.5,1.5,0,0,1,0-3h11.858a1.5,1.5,0,0,1,0,3H443v12.2l9.745,13.07A5.065,5.065,0,0,1,452.853,1908.471Z",
    transform: "translate(-400.655 -1851.713)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarkerLab, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/marker_lab.25ab0c25.svg";
export { ForwardRef as ReactComponent };